import React, { useState } from 'react';
import { Link, useLocation } from 'react-router-dom';

const Sidebar = ({ isOpen }) => {
  const location = useLocation();
  const [openCategories, setOpenCategories] = useState({
    introduction: true,
    core: true,
    integrations: true,
    advanced: true,
    resources: true
  });

  const toggleCategory = (category) => {
    setOpenCategories(prev => ({
      ...prev,
      [category]: !prev[category]
    }));
  };

  const menuStructure = [
    {
      type: 'single',
      path: '/',
      label: 'Accueil',
      icon: '🏠'
    },
    {
      type: 'category',
      key: 'introduction',
      label: 'Introduction',
      items: [
        { path: '/authentication', label: 'Authentication' },
        { path: '/rate-limiting', label: 'Rate Limiting' },
        { path: '/error-codes', label: 'Errors' },
        { path: '/examples', label: 'Code Examples' }
      ]
    },
    {
      type: 'category',
      key: 'core',
      label: 'Core Resources',
      items: [
        { path: '/workspaces', label: 'Workspaces', sublabel: 'List workspaces' },
        { path: '/api-keys', label: 'API Keys', sublabel: 'Manage API keys' },
        { path: '/contacts', label: 'Contacts', sublabel: 'CRUD contacts' },
        { path: '/groups', label: 'Groups', sublabel: 'Manage contact groups' },
        { path: '/templates', label: 'Templates', sublabel: 'Read templates' },
        { path: '/send-template', label: 'Send Template', sublabel: 'Send a WhatsApp template' },
        { path: '/campaigns', label: 'Campaigns', sublabel: 'List & cancel campaigns' }
      ]
    },
    {
      type: 'category',
      key: 'integrations',
      label: 'Webhooks & Integrations',
      items: [
        { path: '/webhooks', label: 'Webhooks', sublabel: 'Receive real-time events' },
        { path: '/integrations', label: 'n8n / Zapier / Make', sublabel: 'Official integrations' }
      ]
    },
    {
      type: 'category',
      key: 'advanced',
      label: 'Advanced',
      items: [
        { path: '/scopes', label: 'Scopes & Permissions', sublabel: 'Fine-grained API key access' }
      ]
    },
    {
      type: 'category',
      key: 'resources',
      label: 'Ressources',
      items: [
        { path: '/support', label: 'Support' }
      ]
    }
  ];

  const isActive = (path) => {
    return location.pathname === path;
  };

  const isCategoryActive = (items) => {
    return items.some(item => isActive(item.path));
  };

  return (
    <nav className={`sidebar ${isOpen ? 'open' : 'closed'}`}>
      <ul className="sidebar-menu">
        {menuStructure.map((item, index) => {
          if (item.type === 'single') {
            return (
              <li key={index}>
                <Link 
                  to={item.path} 
                  className={isActive(item.path) ? 'active' : ''}
                >
                  {item.icon && <span style={{ marginRight: '0.5rem' }}>{item.icon}</span>}
                  {item.label}
                </Link>
              </li>
            );
          }

          if (item.type === 'category') {
            const isOpen = openCategories[item.key];
            const hasActive = isCategoryActive(item.items);

            return (
              <li key={index}>
                <div 
                  className={`menu-category ${hasActive ? 'has-active' : ''}`}
                  onClick={() => toggleCategory(item.key)}
                >
                  <span className="category-label">{item.label}</span>
                  <span className={`category-arrow ${isOpen ? 'open' : ''}`}>▼</span>
                </div>
                {isOpen && (
                  <ul className="submenu">
                    {item.items.map((subItem, subIndex) => {
                      const active = isActive(subItem.path);
                      return (
                        <li key={subIndex}>
                          <Link 
                            to={subItem.path} 
                            className={active ? 'active' : ''}
                          >
                            <span className="submenu-item-label">{subItem.label}</span>
                            {subItem.sublabel && (
                              <span className="submenu-item-sublabel">{subItem.sublabel}</span>
                            )}
                          </Link>
                        </li>
                      );
                    })}
                  </ul>
                )}
              </li>
            );
          }
          return null;
        })}
      </ul>
    </nav>
  );
};

export default Sidebar;